module.exports = __webpack_public_path__ + "img/left-lightning4.d85941af.png";